"use client"
import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Input,
  Button,
  CardBody,
  CardHeader,
  Typography,
  Textarea,
  Rating,
} from "@material-tailwind/react";
import FieldInput from "./Field";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from 'yup';
import Link from "next/link";
import { useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import { getAllProducts, productAdd, reviewAdd, } from "@/API/response";
import { errorNotify, successNotify } from "@/components/Toast";
import { ToastContainer } from "react-toastify";
import ImageUpload from "./UploadImage";


export function AddReview({ isModalOpen, setIsModalOpen, productID }) {
  const { isUser } = useSelector((state) => state.currUser)
  // const router = useRouter()
  // const refFile = useRef([])
  const [dataFiles, setDataFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fileName, setFileNames] = useState([]);

  const adminToken = isUser?.token
  const initialValues = {
    name: "",
    email: "",
    description: "",
    star: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Product name is required")
      .min(3, "Product name must be at least 3 characters"),
    email: Yup.string()
      .email("Invalid email address")
      .required("email is required"),
      star: Yup.number()
      .required("Star is required"),
      // .positive(2, "Compare Price must be a positive number"),

    description: Yup.string()
      .required("description is required")
      .min(5, "Description must be at least 5 characters"),


  });
  const handleSubmit = async (values, { resetForm }) => {
    // console.log("values",values)
    // console.log("productID",productID)
    setIsSubmitting(true);
    const route = 'review/add'
    const data = new FormData()
    data.append("name", values.name)
    data.append("email", values.email)
    data.append("star", values.star)
    data.append("description", values.description)
    data.append("product_Id", productID)
    for (let i = 0; i < dataFiles.length; i++) {
      data.append("images", dataFiles[i]);
    }

    try {
      const response = await reviewAdd(route, data)
      console.log("response",response)
      if (response.message == "Review added successfully") {
        successNotify(response.message)
        setFileNames([])
        setImages([])
        resetForm()
        setTimeout(()=>{
          setIsModalOpen(false)
        },3000)
      } else {
        errorNotify(response.message)
      }
    } catch (error) {
      errorNotify(error || response.message)
    }
    finally {
      setIsSubmitting(false);
    }

  }


  return (
    <div
    >
      <Card
        shadow={false}
        className="  border border-gray-300 overflow-y-auto h-full sm:max-h-[80vh]"
      >
        <CardHeader shadow={false} floated={false} className="text-center">
          <Typography
            variant="h1"
            color="blue-gray"
            className="mb-4 !text-3xl lg:text-4xl"
          >
            Add Review
          </Typography>

        </CardHeader>
        <CardBody>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form
              className="flex flex-col gap-2"
            >
              {/* image uploaded component */}
              <ImageUpload setData={setDataFiles} images={images} setImages={setImages} />
              <span>

                <FieldInput type="text" name='name' placeholder="Customer Name" label="Customer Name" />
                <ErrorMessage name="name" component="div" className="text-red-500 text-sm mt-1" />
              </span>
              <span>
                <FieldInput type="email" name='email' placeholder="Customer Email" label="Customer Email" />
                <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />

              </span>
              <span>
                <FieldInput type="textarea" name='description' placeholder="Review Description" label="Review Description" />
              </span>
              <span>
              <Field name="star">
                {({ field, form }) => (
                  <Rating
                    value={field.value}
                    unratedColor="amber"
                    ratedColor="amber"
                    onChange={(value) => form.setFieldValue("star", value)}
                  />
                )}
                </Field>
                 <ErrorMessage name="star" component="div" className="text-red-500 text-sm mt-1" />
              </span>

              <span className="grid grid-cols-2 gap-2 py-4 ">
                <Button variant="outlined"
                  onClick={() => setIsModalOpen(false)}
                  className="flex h-12 border-blue-gray-200 items-center justify-center gap-" >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full ${isSubmitting ? 'bg-gray-400' : 'bg-secondary hover:cursor-pointer'} text-pureWhite`}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
              </span>
            </Form>
          </Formik>

        </CardBody>
        <ToastContainer />
      </Card>
    </div>

  );
}
